module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-link",
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.valueText)))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0101bf8b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/filterBool.vue
// module id = 477
// module chunks = 0